
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { CommonModule } from '@angular/common'; // Import CommonModule
import { ChangeDetectorRef, Component } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu'; // Import MatMenuModule
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip'; // Import MatTooltipModule
import { Router } from '@angular/router';
import { Assistant } from '@app-libs/model';
import { LoadingSpinnerComponent } from '../../common/components/loading-spinner';
import { AssistantsApiService } from '../../services/api/assistants-api.service';
import { ChatCardComponent } from '../common/chat-card/chat-card.component';
import { DataTableComponent } from '../common/data-table/data-table.component';
import { SearchBarComponent } from '../common/search-bar/search-bar.component';

@Component({
  selector: 'app-assistants',
  imports: [
    MatCardModule,
    CommonModule,
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    MatTooltipModule,
    MatFormFieldModule,
    MatMenuModule,
    ReactiveFormsModule,
    SearchBarComponent,
    DataTableComponent,
    ChatCardComponent,
    LoadingSpinnerComponent
  ],
  templateUrl: './assistants.component.html',
  styleUrls: ['./assistants.component.scss'],
  animations: [
    trigger('fade', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [animate('600ms ease-in', style({ opacity: 1 }))]),
    ]),
  ],
})
export class AssistantsComponent {
  assistants: Assistant[] = [];
  filteredAssistants: Assistant[] = [];
  loading = true;

  // displayedColumns: string[] = ['name', 'description', 'category', 'action'];
  displayedColumns: string[] = ['description', 'action'];
  searchControl = new FormControl('');
  searchPlaceholder = 'Find Tutors';
  listHeadingPlaceholder = 'Tailored AI Tutors';
  searchTooltip = 'Search for tutors by name, description, or category';

  // For data table
  columns = [
    {
      key: 'description',
      header: 'Select an AI Tutor to chat with',
      isDetails: true,
      fields: ['name', 'description'],
      classes: ['name-col', 'description-col'],
    },
    {
      key: 'action',
      header: '',
      isAction: true,
      actionIcon: 'arrow_forward_ios',
      tooltip: 'Chat with this Tutor',
    },
  ];

  constructor(
    private router: Router,
    private assistantsService: AssistantsApiService,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) {
    this.searchControl.valueChanges.subscribe((value) =>
      this.filterAssistants(value || '')
    );
    this.initializeAssistants();
  }

  async initializeAssistants() {
    // this.assistants =
    //   (await this.assistantsService
    //     .getAllAssistantsForUI(100, true)
    //     .toPromise()) || [];
    this.assistants = await this.assistantsService.getAssistantsForWorkspace().toPromise() || [];
    console.log('Fetched assistants:', this.assistants);
    this.filteredAssistants = this.assistants;
    this.loading = false;
    this.cdr.detectChanges(); // Ensure the view is updated
  }

  filterAssistants(query: string) {
    console.log('Filtering assistants with query:', query);
    let regex: RegExp;
    try {
      regex = new RegExp(query, 'i');
    } catch (e) {
      console.error('Invalid regex:', e);
      this.snackBar.open('Invalid regex pattern', 'Close', {
        duration: 3000,
      });
      return;
    }

    this.filteredAssistants = this.assistants?.filter(
      (assistant) =>
        regex.test(assistant.name || '') ||
        regex.test(assistant.description || '') ||
        regex.test(assistant.hierarchy_path?.toString() || '') ||
        assistant.name?.toLowerCase().includes(query.toLowerCase()) ||
        assistant.description?.toLowerCase().includes(query.toLowerCase()) ||
        assistant.hierarchy_path
          ?.toString()
          .toLowerCase()
          .includes(query.toLowerCase())
    );
    console.log('Filtered assistants:', this.filteredAssistants);
  }

  async talkToAssistant(event: any, assistant: Assistant) {
    console.log(`Talking to ${assistant.name}`);

    event.preventDefault();
    event.stopPropagation();

    this.router.navigate(['/tutors/chat', assistant.assistant_id], {
      state: { chatType: 'assistant' },
    });
  }

  onRowClick(event: any) {
    console.log('Row clicked:', event);
    this.talkToAssistant(event.event, event.row);
  }

  onActionClick(event: any) {
    console.log('Action clicked:', event);
    this.talkToAssistant(event.event, event.row);
  }
}
